import { AIStatus, AIModel } from '@mygpt/app/apis';
import { AIType } from '@mygpt/app/datasets/services';
import { Http, PageData, PageQuery } from '@mygpt/app/http';
import { User } from '@mygpt/app/users/services/get-enterprise-plan-list';

// 分享来源类型：组织内 / 组织外
export type ShareSource = 'organization' | 'external';

export interface CollaborativeItem {
  created_at: string;
  id: string;
  user: User;
  name: string;
  discrible: string;
  subject_name: string;
  prompt: string;
  ai_type: AIType;
  ai_model: AIModel;
  ai_status: AIStatus;
  // 分享来源（组织内/组织外），由后端返回
  share_source?: ShareSource;
}

export interface CollaborativeListParams extends PageQuery {
  // 筛选分享来源：organization = 组织内分享, external = 组织外分享
  share_source?: ShareSource;
}

/**
 * 获取受邀协作机器人列表
 * @param params
 * @returns
 */
export const getCollaborativeList = (params: CollaborativeListParams) => {
  const { get } = Http.use();
  const { share_source, ...rest } = params;
  const queryParams = {
    ...rest,
    ...(share_source && { share_source }),
  };
  return get<PageData<CollaborativeItem>>(`/users/members`, {
    params: queryParams,
  });
};
